import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Button,
  Text,
  useToast,
} from '@chakra-ui/react'
import { useDeleteSeatingPlan } from 'queries/seatingPlan.query'

export function DeletePlanModal({ isOpen, onClose, plan }) {
  const toast = useToast()
  const deletePlanMutation = useDeleteSeatingPlan()

  const handleDelete = async () => {
    if (!plan) return
    try {
      await deletePlanMutation.mutateAsync(plan.id)
      toast({
        title: 'Plan deleted',
        description: 'Seating plan removed successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
      onClose()
    } catch (err) {
      toast({
        title: 'Failed to delete plan',
        description: err?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
      })
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Seating Plan</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>
            Are you sure you want to delete <strong>{plan?.name}</strong>?
            Events linked to this plan will no longer display it.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="red"
            onClick={handleDelete}
            isLoading={deletePlanMutation.isPending}
          >
            Delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
